module.exports = __webpack_public_path__ + "static/img/Mini-intro-videoIMG.0464575.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/Mini-intro-videoIMG.jpg
// module id = PFB5
// module chunks = 12